<template>
  <v-app @mouseover.native="onMouseMoveOver" id="inspire">
    <div id="app">
      <top-navbar v-if="checkLocalStorageUserId()  && !(status)"></top-navbar>
      <flash-message class="myCustomClass" id="myCustomClass"></flash-message>
      <router-view></router-view>
      <logOffDialog v-if="dialog" :dialog="dialog" @closeDialog="closeDialog"/>
      <content-footer></content-footer>
    </div>
  </v-app>
</template>

<script>
import TopNavbar from "./components/TopNavbar.vue";
import { EventBus } from './main.js';
import logOffDialog from './components/Dialogs/LoggOffDialog'
import ContentFooter from "./components/ContentFooter.vue";
export default {
  name: 'App',
  components: {
    TopNavbar,
    logOffDialog,
    ContentFooter,
  },
  mounted(){
    if(!((window.location.pathname.includes('/iso/accepted_offer') 
        || window.location.pathname.includes('/iso/reject_offer') 
        || window.location.pathname.includes('/subform')
      ) && this.$route.params.user_id)){
      this.timeChecker()
      EventBus.$on("logOffDialog", (status) => {
        this.dialog = true
      });
    }
    // if(!(window.location.pathname.includes('/iso/accepted_offer') && this.$route.params.user_id)){
    //   this.timeChecker()
    //   EventBus.$on("logOffDialog", (status) => {
    //     this.dialog = true
    //   });
    // }
  },

  data () {
    return {
      dialog: false,
    }
  },
  computed: {
    status(){
      return window.location.pathname.includes('/login')
    }
  },
  // watch:{
  //   '$route.path': {
  //     handler(val){
  //       debugger
  //     },
  //     deep: true
  //   }
  // },
  methods: {
    closeDialog(){
      this.dialog = false
    },
    timeChecker() {
      let app = this;
      var storedTimeStamp = localStorage.getItem("lastTimeStamp");
      app.timeCompare(storedTimeStamp);
    },
    timeCompare(timeString) {
      let app = this;
      var maxMinutes = 0.5 * 15 // * 2; // means (1min * 60 * 2) = 2 hours //GREATER THEN 1440 MIN OR 24 HOURS.
      var currentTime = new Date();
      var pastTime = new Date(timeString);
      var timeDiff = currentTime - pastTime;
      var minPast = Math.floor(timeDiff / 60000);
      if (timeString) {
        if (minPast >= maxMinutes) {
          localStorage.removeItem("lastTimeStamp");
          localStorage.removeItem('user_id')
          localStorage.removeItem('email')
          localStorage.removeItem('access_token')
          localStorage.removeItem('password')
          localStorage.removeItem('name')
          localStorage.removeItem('syndication_id')
          this.$router.push('/login');
          return false;
        } else {
          EventBus.$emit('logoutEvent', 'logout');
        }
      }
    },
    onMouseMoveOver() {
      if (typeof Storage !== "undefined") {
        var timeStamp = new Date();
        localStorage.setItem("lastTimeStamp", timeStamp);
      }
    },
    checkLocalStorageUserId(){
      let user_id = localStorage.getItem("user_id");
      if(user_id && user_id!="0" && !(window.location.pathname.includes('/subform') && this.$route.params.user_id)){
        return true
      }
      return false
    }
  }
}
</script>

<style>
#app {  
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /*margin-top: 60px;*/
}

body {
  background-color: #e5e5e5;
}
</style>
